import { Component, Input } from '@angular/core';

@Component({
    selector   : 'my-modal',
    template: require('./modal.component.html'),
    styles: [require('./modal.component.scss')]
})

export class ModalComponent {

    @Input('title') title: string;
    @Input('open') open: any;
    @Input('name') name:string;
    @Input('style') style:string;
    @Input('body') body:string;
    @Input('actions') actions: any;
    @Input('model') model: any;
    @Input('options') option: any;
    @Input('inputs') inputs: any;

    public footer: string;

    constructor() {

    }

    close(){
        this.open[this.name] = false;
    }

    click(action:string){
        if (this.option)
            this.model[action](this.option);
        else if (this.inputs)
            this.model[action](this.inputs);
        else
            this.model[action]();
        this.close();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/modal/modal.component.ts